import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "py-3 footer"
};
const _hoisted_2 = {
  class: "container-fluid"
};
const _hoisted_3 = {
  class: "row align-items-center justify-content-lg-between"
};
const _hoisted_4 = {
  class: "mb-4 col-lg-6 mb-lg-0"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(["text-sm text-center copyright text-muted", $data.isRTL ? 'text-lg-end' : 'text-lg-start'])
  }, [_createTextVNode(" © " + _toDisplayString(new Date().getFullYear()) + ", made with ", 1), _cache[0] || (_cache[0] = _createElementVNode("i", {
    class: "fa fa-heart"
  }, null, -1)), _cache[1] || (_cache[1] = _createTextVNode(" by ")), _cache[2] || (_cache[2] = _createElementVNode("a", {
    href: "https://appg.co.kr",
    class: "font-weight-bold",
    target: "_blank"
  }, "APPG INC", -1)), _cache[3] || (_cache[3] = _createTextVNode(" for a better web. "))], 2)])])])]);
}